import { finishMeta } from "@/lib/cards";
import { cn } from "@shared/lib/utils";

type RarityBadgeProps = {
  finish: string;
  /** R-25: "/N" 발행 수량은 등급 정체성 — 시리얼 한정 티어는 항상 병기 */
  showSupply?: boolean;
  className?: string;
};

/**
 * 희귀도 배지 — 색 단독 의존 금지(R-26): 등급명 텍스트를 항상 함께 표기하고,
 * 색은 finishMeta 강조색을 따른다. §1.3 색+아이콘 이중 부호화(색맹 대응):
 * ● 오픈 에디션 / ◆ 시리얼 한정 / ★ 1-of-1.
 */
export function RarityBadge({ finish, showSupply = true, className }: RarityBadgeProps) {
  const meta = finishMeta(finish);
  const icon = meta.supplyCap === 1 ? "★" : meta.supplyCap != null ? "◆" : "●";
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border border-line bg-white/4 px-2.5 py-1 font-mono text-[10px] font-medium uppercase tracking-[0.12em]",
        meta.accentText,
        className,
      )}
    >
      <span aria-hidden className="text-[8px] leading-none">
        {icon}
      </span>
      {meta.label}
      {showSupply && meta.supplyCap != null && (
        <span className="text-ink-mute">/{meta.supplyCap}</span>
      )}
    </span>
  );
}
